const RoleConstants = {
    ROLE_ADD_FORM: 'ROLE_ADD_FORM',
    ROLE_INVALID_ADD: 'ROLE_INVALID_ADD',
    ROLE_GET_ALL: 'ROLE_GET_ALL',
    ROLE_GET_DETAIL: 'ROLE_GET_DETAIL',
    ROLE_BEGIN_ADD: 'ROLE_BEGIN_ADD',
    ROLE_BEGIN_EDIT: 'ROLE_BEGIN_EDIT',
    ROLE_FINISH_EDIT: 'ROLE_FINISH_EDIT',
    ROLE_UPDATE_EDIT: 'ROLE_UPDATE_EDIT',
    ROLE_DELETE: 'ROLE_DELETE',
    ROLE_ADD: 'ROLE_ADD',
    ROLE_EDIT: 'ROLE_EDIT',
    ROLE_ADD_USER: 'ROLE_ADD_USER',
    ROLE_DELETE_USER: 'ROLE_DELETE_USER',
    ROLE_RECIEVE_SETTINGS_DATA: 'ROLE_RECIEVE_SETTINGS_DATA',
    ROLE_ADD_EXTERNAL_GROUP: 'ROLE_ADD_EXTERNAL_GROUP',
    ROLE_DELETE_EXTERNAL_GROUP: 'ROLE_DELETE_EXTERNAL_GROUP',
    ROLE_DIRECTORY_GROUP_SEARCH: 'ROLE_DIRECTORY_GROUP_SEARCH',
    ROLE_RECEIVE_SEARCH_HINT: 'ROLE_RECEIVE_SEARCH_HINT',
} as const;

export default RoleConstants;
